<template>                
  <tr class="pricing-table__row" :class="{ 'pricing-table__row--highlight': shouldHighlight(), 'pricing-table__row--disabled': loading }">
    <td class="pricing-table__cell pricing-table__cell--xsm pricing-table__sort-handle">{{ ordinal }} <i class="fa fa-ellipsis-v"></i></td>
    <td class="pricing-table__cell pricing-table__cell--xl pricing-table__cell--has-right-btn">
      <button class="pricing-table__btn--label btn btn-sm btn-tertiary btn-icon mrgn-0 pad-right-0" style="position: relative; top: auto; font-size: 12px; text-align: left;" 
        v-if="label"
        @click="loadSavedPricingRequest"
        :title="nameTooltipText"
        :aria-label="label"
      > {{ label }}</button>
      <button class="btn btn-sm btn-tertiary btn-icon mrgn-0 pad-right-0" style="position: relative; top: auto; font-size: 12px; text-align: left;"
        :title="nameTooltipText"
        v-else
        @click="loadSavedPricingRequest"
      >-Not Defined-</button>

      <button class="btn btn-secondary btn-icon pricing-table__btn pricing-table__btn--config"
        @click="toggleModal"
      ><i class="fa fa-gear"></i></button>
    </td>
    <td class="pricing-table__cell pricing-table__cell--sm-a"><span class="pricing-table__val pricing-table__val--no-wrap"
      :class="{'pricing-table__val--alert' : status === 'Inactive'}"
      :title="facilityProfile" 
      :aria-label="facilityProfile" 
    >{{ status }}</span></td>
    <td class="pricing-table__cell pricing-table__cell--table-parent">
      <table class="pricing-table__subtable" cellpadding="0" cellspacing="0">
        <term-row 
          v-for="(term, index) in activeTerms"
          :key="index"
          :display-unit="displayUnit"
          :start-month="startMonth"
          :term-length="term.term"
          :usage="(pricingData.terms && pricingData.terms[term.term]) ? pricingData.terms[term.term].usage : null"
          :primary-pricing-component="primaryPricingComponent"
          :pricing-alerts="pricingAlerts"
          :time-based-alerts="timeBasedAlerts"
          :pricing-data="pricingData"
          :alert-trigger="alertTrigger"
          :created="created"
          :updated="updated"
        ></term-row>
      </table>

      <config-modal
        @toggleModal="toggleModal"
        @waitForUpdatedRequests="waitForUpdatedRequests"
        :key="configModalKey"
        :allow-config-modal="allowConfigModal"
        :modal-visible="modalVisible"
        :ordinal="ordinal"
        :label="label"
        :facility-profile="facilityProfile"
        :pricing-data="pricingData"
        :pricing-components="pricingComponents"
        :primary-pricing-component="primaryPricingComponent"
        :existing-supply-price="existingSupplyPrice"
        :pricing-alerts="pricingAlerts"
        :time-based-alerts="timeBasedAlerts"
        :pricing-request="pricingRequest"
        :pricing-request-id="pricingRequestId"
        :term-length="termLength"
      ></config-modal>
      
    </td>
    <td class="pricing-table__cell pricing-table__cell--xsm pricing-table__cell--button-parent">
      <div class="pricing-table__button-wrap">

        <button 
          type="button"
          ref="adjustmentButton"
          class="btn btn-secondary btn-icon pricing-table__btn pricing-table__btn--adjustment mrgn-right-5" 
          :data-bs-title="notesTooltipText"
          @click="editNotes()"
        >
          <i 
            :class="{ 
              'fa fa-file-text': brokerFee,
              'fa fa-file-text-o': !brokerFee,
            }"
            aria-hidden="true"></i>
        </button>

        <button 
          class="btn btn-secondary btn-icon pricing-table__btn pricing-table__btn--delete"
          @click="deleteRow"
        ><i class="fa fa-trash-o"></i></button>

      </div> <!-- .pricing-table__button-wrap -->
    </td>
  </tr>
</template>

<script>
import { Tooltip } from 'bootstrap'
import { cloneDeep } from 'lodash'
import { nextTick } from 'vue'
import axios from 'axios'
import swal from 'sweetalert'
import TermRow from './TermRow.vue'
import ConfigModal from './ConfigModal.vue'
import { formatCurrency } from  '../../../common/helpers.js'

let uuid = 0

export default {
  props: ['index', 'displayUnit', 'pricingRequest', 'pricingRequestId', 'currentPricingRequestId', 'pricingData', 'ordinal', 'label', 'facilityProfile', 'startMonth', 'termLength', 'volume', 'primaryPricingComponent', 'existingSupplyPrice', 'pricingAlerts', 'timeBasedAlerts', 'created', 'updated', 'alertTrigger', 'loading'],
  components: {
    'term-row': TermRow,
    'config-modal': ConfigModal
  },
  data() {
    return {
      modalVisible: false,
      optionSetId: 'option-set-' + uuid,
      maxTriggerPriceDecimalPlaces: 4,
      configModalKey: 0,
    }
  },
  beforeCreate() {
    uuid += 1;
  },
  mounted() {
    Tooltip.getOrCreateInstance(this.$refs.adjustmentButton)
  },
  watch: {
    savedPricingRequests() {
      this.configModalKey += 1
    },

    // Set the content of the adjustment/notes button tooltip when the 
    // broker fee changes.
    brokerFee(newVal) {
      const tooltip = Tooltip.getOrCreateInstance(this.$refs.adjustmentButton)
      tooltip.setContent({ '.tooltip-inner': formatCurrency(newVal) + '/KWh' })
    },
  },
  filters: {
    truncate(text, length, suffix) {
      if (text && text.length >= length + 3) {
        return text.substring(0, length) + suffix;
      }
      return text
    }
  },
  computed: {
    uuid() {
      return uuid
    },
    savedPricingRequests() {
      return this.$store.getters.savedPricingRequests
    },
    dashboardSortUtility() {
      return this.$store.getters.dashboardSortUtility
    },
    pricingComponents() {
      return this.$store.getters.dashboardPricingComponents
    },
    timezone() {
      return this.$store.getters.userTimezone
    },
    activeTerms() {
      let activeTerms = this.termLength

      if (activeTerms.length > 0) {
        activeTerms = activeTerms.filter(item => {
          return item.term != ''
        })
        return activeTerms
        
      } else {
        let incompleteTermRow = [{
          term: ''
        }]

        return incompleteTermRow
      }
    },
    terms() {
      return this.termLength
    },
    /**
     * Determine if the price request uses a custom facility profile.
     */
    customFacilityProfileExists() {
      return this.pricingRequest?.inputs?.customFacilityProfile && 
             Object.keys(this.pricingRequest.inputs.customFacilityProfile).length > 0
    },
    /**
     * Get the price request's adjustment/broker fee.
     */
    brokerFee() {
      if (this.customFacilityProfileExists) {
        return this.pricingRequest?.inputs?.customFacilityVolume?.brokerFee
      }

      return this.pricingRequest?.inputs?.volume?.brokerFee
    },
    /**
     * Get the status label for the price request.
     */
    status() {
      if (new Date(this.startMonth) < new Date()) {
        return 'Inactive'
      } 

      return 'Active'
    },
    /**
     * Get the date the price request was created.
     */
    createdAt() {
      if (this.created) {
        return new Intl.DateTimeFormat('en-US', {"year":"numeric","month":"numeric","day":"numeric"}).format(new Date(this.created))
      }
      return null
    },
    /**
     * Get the date the price request was last updated.
     */
    updatedAt() {
      if (this.updated) {
        return new Intl.DateTimeFormat('en-US', {"year":"numeric","month":"numeric","day":"numeric"}).format(new Date(this.updated))
      }
      return null
    },
    /**
     * Get the content for the name tooltip.
     */
    nameTooltipText() {
      let lines = []

      if (this.label) {
        lines.push(this.label)
      }

      if (this.pricingRequest.creator_info) {
        lines.push('Created by: ' + this.pricingRequest.creator_info.display_name)
      }

      if (this.createdAt) {
        lines.push('Created: ' + this.createdAt)
      }

      return lines.join("\n")
    },
    /**
     * Get the content for the adjustment/notes tooltip.
     */
    notesTooltipText() {
      if (this.brokerFee) {
        return formatCurrency(this.brokerFee, 6) + '/KWh'
      }

      return 'No adjustment'
    },
    allowConfigModal() {
      if (this.dashboardSortUtility && (this.dashboardSortUtility.plan.slug === 'registered' || this.dashboardSortUtility.plan.slug === 'free-registered')) {
        return false
      }
      return true
    }
  },
  methods: {
    shouldHighlight() {
      
      // Is this the currently-load price request?
      if (this.currentPricingRequestId == this.pricingRequestId) {
        return true
      }

      // or via "uiid" URL query param (user_inputs id)?
      let urlParams = new URLSearchParams(window.location.search)
      if (urlParams.has('uiid') && urlParams.get('uiid') == this.pricingRequestId) {
        return true
      }
      
      return false
    },
    toggleModal() {
      this.modalVisible = !this.modalVisible

      // Set the current price request ID so that this row is highlighted 
      // when we close the config modal.
      this.$store.commit('SET_SAVED_PRICING_REQUEST_ID', this.pricingRequestId)

      nextTick(() => {
        if (!this.modalVisible) {
          this.$emit('refreshPricingRequests')
        }
      })
    },
    waitForUpdatedRequests() {
      this.$emit('waitForUpdatedRequests')
    },
    updatePrimaryPricingComponent(pricingComponent) {
      let inputs = cloneDeep(this.pricingRequest.inputs)

      inputs.primaryPricingComponent = pricingComponent

      axios.put('/pricing-calculator/me/inputs/' + this.pricingRequestId, inputs)
    },
    loadSavedPricingRequest() {
      let payload = {
        id: this.pricingRequestId,
        viaUrl: false
      }
      this.$store.dispatch('loadSavedPricingRequest', payload)
    },
    deleteRow() {
      let swalContent = document.createElement('div')
      swalContent.innerHTML = '<p class="alerts message alerts--no-brdr alerts--close-btn">This action will permanently delete this set of saved inputs. Do you want to continue?</p>'

      swal({
        content: swalContent,
        closeOnEsc: false,
        closeOnClickOutside: false,
        buttons: {
          cancel: {
            text: 'Cancel',
            value: null,
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: 'Yes',
            value: true,
            visible: true,
            closeModal: true,
          }
        }
      }).then((result) => {
        if (result) {
          this.$emit('waitForUpdatedRequests')
          this.$store.dispatch('deleteInputSet', this.pricingRequestId) 
        }
      })
    },
    /**
     * Format currency.
     */
    formatCurrency(val) {
      return formatCurrency(val)
    },
    /**
     * Show the notes modal.
     */
    editNotes() {
      this.$emit('editNotes', this.pricingRequest)
    },
  },
}
</script>
